import { render, staticRenderFns } from "./LoteExtra.vue?vue&type=template&id=631ff725"
import script from "./LoteExtra.vue?vue&type=script&lang=js"
export * from "./LoteExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports